import React from 'react';
import PropTypes from 'prop-types';

export default function Loader(props) {
  return (
    <div className="a-loader" />
  );
};
